<template>
  <div>
    <div class="rse-block-card border p-3 d-flex flex-column">
      <div class="d-flex align-items-center gap-3">
        <!-- Image container to ensure alignment -->
        <div class="rse-image-wrapper justify-content-center d-flex" style="min-width: 95px;">
          <img
            :src="icon"
            alt="icon"
          />
        </div>


        <div class="rse-block-text-area d-flex flex-column gap-1 flex-grow-1">
          <div class="rse-block-text body">
            {{ description }}
          </div>
          <div
            class="link-large-underline link-default read-more cursor-pointer align-self-end"
            @click="openLink"
          >
            <span>{{ content.planner_prestationsMoreInfo }}</span>
            <span>
              <svg style="color: var(--primary-blue);" width="10" height="10">
                <use xlink:href="#___icon___chevron-right-bold"></use>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { RSE_LINKS } from '@/vue/responsible-stay/config/index';

// Define interface for the props
interface IRSECard {
  title: string;
  description: string;
  icon: string;
  linkKey: string;
}

// Props
const props = defineProps<IRSECard>();

// Refs
const content = ref<{ [key: string]: string }>(window.content);

// Function to open the correct link in a new tab
const openLink = () => {
  const url = RSE_LINKS[props.linkKey];
  if (url) {
    window.open(url, '_blank');
  } else {
    console.warn('No link found for key:', props.linkKey);
  }
};
</script>
<style scoped>
.rse-block-card {
  border-radius: var(--border-radius-card);
}

/* Mobile: Enable responsive layout */
@media (max-width: 768px) {
  .rse-block-card > div:first-of-type {
    flex-direction: column;
  }
}
</style>

